export class PushMessageSelection {

  id: string;
  sessionId: number;
  key: string;
  value: string;

}